import React, { useState, useRef } from "react";
import { Trans } from "@lingui/macro";
import { Portal } from 'react-portal';
import BEMHelper from "react-bem-helper";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { authorise } from "@/reducers/pincode";
import NumPad from "./NumPad";

import './NumPad.css'

export const c = new BEMHelper({
  name: "PincodeAuth",
});

type Props = {
  
};

const PincodeAuth: React.FC<Props> = () => {
  const pincode = useAppSelector((s) => s.pincode.entity);
  const dispatch = useAppDispatch();
  const ref = useRef(null)

  const comparePincode = (enteredPincode: string) => {
    if (pincode.code === enteredPincode) {
      dispatch(authorise());
    }
  };

  return pincode.code && !pincode.authorised ? (
    <div ref={ref}>
      {/* @ts-ignore */}
      <Portal node={ref.current?.getRootNode().querySelector('#bokamera-embedded')}>
        <div {...c('numpad')}>
          <h2><Trans id="PinCodeAuth.enterPincode" /></h2>
          <NumPad
            buttonStyle={{ width: "90px", height: "90px" }}
            pinCode={pincode.code}
            onChange={(val) => {
              comparePincode(val);
            }}
          />
        </div>
        <div {...c('backdrop')} />
      </Portal>
    </div>
  ) : null;
};

export default PincodeAuth;
